<template>
  <button
    type="button"
    class="tu-filter-toggle"
    :class="{ 'tu-filter-toggle--on': active, 'tu-filter-toggle--compact': compact }"
    :aria-pressed="active ? 'true' : 'false'"
    @click="$emit('toggle')"
  >
    <span class="tu-filter-toggle__text">
      <span class="tu-filter-toggle__label">{{ label }}</span>
      <span v-if="!compact" class="tu-filter-toggle__value">{{ active ? value : 'Off' }}</span>
    </span>
    <span class="tu-filter-toggle__switch" aria-hidden="true"><i /></span>
  </button>
</template>

<script>
/** On/off filter in the TransitionU filter bar chrome. `compact` is a one-line version for a results row. */
export default {
  name: 'TuFilterToggle',
  props: {
    label: { type: String, required: true },
    value: { type: String, default: 'On' },
    active: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
.tu-filter-toggle {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  min-width: 0;
  min-height: 56px;
  padding: 0 16px 0 18px;
  border: 0;
  background: transparent;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  transition: background 0.15s;
  &:hover { background: var(--tu-surface-2, #f5f6f8); }
  &:focus-visible { outline: 0; box-shadow: inset 0 0 0 2px var(--tu-blue, #3b86f5); border-radius: 12px; }
}
.tu-filter-toggle__text { display: flex; flex-direction: column; gap: 2px; min-width: 0; flex: 1; line-height: 1.15; }
.tu-filter-toggle__label { font-size: 10.5px; font-weight: 700; letter-spacing: 0.07em; text-transform: uppercase; color: var(--tu-ink-mute, rgba(24, 24, 24, 0.55)); }
.tu-filter-toggle__value { font-size: 14.5px; font-weight: 600; color: var(--tu-ink, #181818); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.tu-filter-toggle--on .tu-filter-toggle__value { color: var(--tu-blue-deep, #245fcc); }
.tu-filter-toggle__switch { flex: none; width: 34px; height: 20px; border-radius: 999px; background: var(--tu-line, rgba(24, 24, 24, 0.1)); transition: background 0.15s; position: relative; }
.tu-filter-toggle__switch i { position: absolute; top: 2px; left: 2px; width: 16px; height: 16px; border-radius: 50%; background: #fff; box-shadow: 0 1px 3px rgba(24, 24, 24, 0.25); transition: transform 0.15s; }
.tu-filter-toggle--on .tu-filter-toggle__switch { background: var(--tu-blue, #3b86f5); }
.tu-filter-toggle--on .tu-filter-toggle__switch i { transform: translateX(14px); }
.tu-filter-toggle--compact { width: auto; min-height: 36px; padding: 0 8px; gap: 10px; border-radius: 8px; }
.tu-filter-toggle--compact .tu-filter-toggle__label { font-size: 13px; font-weight: 500; letter-spacing: 0; text-transform: none; color: var(--tu-ink-soft, rgba(24, 24, 24, 0.72)); white-space: nowrap; }
.tu-filter-toggle--compact.tu-filter-toggle--on .tu-filter-toggle__label { color: var(--tu-ink, #181818); font-weight: 700; }
</style>
